export { default } from './ImageCheckQuestionContainer';
